import { render, staticRenderFns } from "./educationDetailsView.vue?vue&type=template&id=d5831f76&"
import script from "./educationDetailsView.vue?vue&type=script&lang=js&"
export * from "./educationDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports